import { StyleSheet } from 'react-native';
import { tokens } from '../design-system/tokens';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  list: {
    flex: 1,
  },
  listContent: {
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.md,
  },
  rowSelf: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginVertical: tokens.spacing.xxs,
  },
  rowOther: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginVertical: tokens.spacing.xxs,
  },
  bubble: {
    maxWidth: '75%',
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.lg,
  },
  bubbleSelf: {
    borderBottomRightRadius: tokens.radius.xs,
  },
  bubbleOther: {
    borderBottomLeftRadius: tokens.radius.xs,
  },
  bodyText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    lineHeight: tokens.typography.fontSize.body * tokens.typography.lineHeight.normal,
    marginBottom: tokens.spacing.xxs,
  },
  timestampText: {
    fontSize: tokens.typography.fontSize.caption,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    alignSelf: 'flex-end',
  },
  composerContainer: {
    flexDirection: 'row',
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.md,
    borderTopWidth: 1,
    gap: tokens.spacing.sm,
    alignItems: 'flex-end',
  },
  composerInput: {
    flex: 1,
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.lg,
    maxHeight: 120,
    minHeight: 40,
  },
  sendButton: {
    paddingHorizontal: tokens.spacing.lg,
    paddingVertical: tokens.spacing.sm,
    borderRadius: tokens.radius.lg,
    minHeight: 40,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 60,
  },
  sendButtonText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.semibold}` as any,
  },
  composerPlaceholder: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.md,
    borderRadius: tokens.radius.lg,
    opacity: 0.5,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: tokens.spacing.xxl,
  },
  emptyText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    textAlign: 'center',
    lineHeight: tokens.typography.fontSize.body * tokens.typography.lineHeight.relaxed,
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: tokens.spacing.xxl,
  },
  errorText: {
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.regular}` as any,
    textAlign: 'center',
    lineHeight: tokens.typography.fontSize.body * tokens.typography.lineHeight.relaxed,
    marginBottom: tokens.spacing.lg,
  },
  retryButton: {
    paddingHorizontal: tokens.spacing.xl,
    paddingVertical: tokens.spacing.md,
    borderRadius: tokens.radius.lg,
  },
  retryButtonText: {
    color: tokens.color.semantic.light.surface.primary,
    fontSize: tokens.typography.fontSize.body,
    fontWeight: `${tokens.typography.fontWeight.semibold}` as any,
  },
  skeletonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginVertical: tokens.spacing.xxs,
  },
  skeletonBubble: {
    width: '60%',
    height: 60,
    borderRadius: tokens.radius.lg,
    opacity: 0.3,
  },
});
